import { Component, Input } from '@angular/core';
import { ExternalMember } from '../../../shared/models/member/external-member.model';

@Component({
  selector: 'def-b2b-registration-form',
  templateUrl: './b2b-registration-form.component.html',
})
export class B2bRegistrationFormComponent {
  @Input() member: ExternalMember;
}
